/**
 * Localization configuration
 * Defines available languages and storage keys
 */

// Available languages
export const LANGUAGES = {
  EN: 'en',
  FR: 'fr'
};

// Language storage key
export const LANGUAGE_KEY = 'autobot_language';

// Default language
export const DEFAULT_LANGUAGE = LANGUAGES.FR;
